const { cELM } = require("../../utils");

class InsuranceQuestion {
  constructor(params, cssname) {
    this._params = params;
    this._data = params.data;
    this._instructionsText = getLngTxt('imageUpload.instructionsText') || "Try to center the card against a dark background and make sure all four corners are visible.";
    this.elm = cELM("div", "question-block insurance");
    if (params.data.format && params.data.format.includes('back')) {
      this.instructions = cELM("div", "insurance-instructions back");
      this.instructions.setAttribute('insurance-instructions-content', this._instructionsText);
    }
    else {
      this.instructions = cELM("div", "insurance-instructions front");
      this.instructions.setAttribute('insurance-instructions-content', this._instructionsText);
    }

    if (params.data && params.data.text) {
      this.questionText = cELM("span", "question-text");
      this.questionText.innerHTML = params.data.text;
      this.elm.addELM(this.questionText);
      if (params.data.subtext) {
        this.questionSubText = cELM("span", "question-text subtext");
        this.questionSubText.innerHTML = params.data.subtext;
        this.elm.addELM(this.questionSubText);
      }
    }

    this.instructionsContainer = cELM("div", "instructions-container");
    this.instructionsContainer.addELM(this.instructions)
    this.elm.addELM(this.instructionsContainer);

    if (cssname) {
      this.elm.classList.add(cssname);
    }
  }

  update(type, data, reference) {
    throw "TODO: implementation";
  }

  hideImage() {
    _imgAreaBottom.className = "image-bottom hidden";
  }

  blur() {
    let inps = elm.querySelectorAll("input");
    for (let i = 0; i < inps.length; i++) {
      inps[i].blur();
    }
  }

  getData() {
    return this._data;
  }

  getHTML() {
    return this.elm;
  }
}

module.exports = InsuranceQuestion;
